const MS_PER_DAY = 1000 * 60 * 60 * 24;

// Correctly handles dates which span time-zones
export const daysDifference = (dateA: Date, dateB: Date) => {
  const utc1 = Date.UTC(dateA.getFullYear(), dateA.getMonth(), dateA.getDate());
  const utc2 = Date.UTC(dateB.getFullYear(), dateB.getMonth(), dateB.getDate());
  return Math.floor((utc1 - utc2) / MS_PER_DAY);
};
